import _ from 'lodash';
import Fuse from 'fuse.js';

export function filterProjects(projects, filters) {
	let filtered = projects.filter((project) => {
		return (
			filters.studios.selected.length === 0
			|| filters.studios.selected.includes(project.studio?.slug)
		);
	});

	const q = filters.searchText?.trim();
	if(!q) {
		return filtered;
	}

	return new Fuse(filtered, {
		keys: ['name'],
		threshold: 0.35,
		distance: 80,
		minMatchCharLength: 2,
		ignoreLocation: true
	}).search(q)
		.map((r) => r.item);
}

export function buildStudioOptions({ studios, projects }) {
	return studios.map((studio) => {
		let count =
			_.countBy(projects, (project) => {
				return project.studio?.name;
			})[studio.name] || 0;
		return {
			label: studio.name,
			value: studio.slug,
			count
		};
	});
}
